module.exports = __webpack_public_path__ + "img/mobile/Background/fs_background_pt@2.25x.jpg?1.1.2";